import React, { useState, useEffect, useContext } from 'react';
import { NotificationContext } from '../../context/NotificationContext';
import api from '../../api';

const RequestTypeManager = ({ configId }) => {
  const { showNotification } = useContext(NotificationContext);
  const [requestTypes, setRequestTypes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    length: ''
  });

  useEffect(() => {
    loadRequestTypes();
  }, [configId]);

  const loadRequestTypes = async () => {
    try {
      const response = await api.get(`/admin/request_types/${configId}`);
      setRequestTypes(response.data);
    } catch (error) {
      showNotification('Error loading request types: ' + error.message, true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submissionData = {
        configuration_id: parseInt(configId),
        name: formData.name,
        description: formData.description || undefined,
        length: formData.length ? parseInt(formData.length) : undefined
      };

      await api.post('/admin/request_types/', submissionData);
      showNotification('Request type added successfully!');
      setIsModalOpen(false);
      setFormData({
        name: '',
        description: '',
        length: ''
      });
      loadRequestTypes();
    } catch (error) {
      showNotification('Failed to add request type: ' + error.message, true);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this request type?')) return;

    try {
      await api.delete(`/admin/request_types/${id}`);
      showNotification('Request type deleted successfully!');
      loadRequestTypes();
    } catch (error) {
      showNotification('Failed to delete request type: ' + error.message, true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="section-card">
      <div className="section-header">
        <h2>Request Types</h2>
        <button 
          className="add-entity-btn"
          onClick={() => setIsModalOpen(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd"/>
          </svg>
          <span>Add Request Type</span>
        </button>
      </div>
      
      <div className="section-content">
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Length</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requestTypes.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-gray-500">
                    No request types found.
                  </td>
                </tr>
              ) : (
                requestTypes.map(requestType => (
                  <tr key={requestType.id}>
                    <td>{requestType.name}</td>
                    <td>{requestType.description || '-'}</td>
                    <td>{requestType.length ? `${requestType.length} minutes` : '-'}</td>
                    <td>
                      <button 
                        onClick={() => handleDelete(requestType.id)}
                        className="text-red-600 hover:text-red-800 font-medium"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && (
        <div className="section-modal">
          <button 
            className="modal-close"
            onClick={() => setIsModalOpen(false)}
          >
            ×
          </button>
          <h3>Add Request Type</h3>
          <form onSubmit={handleSubmit}>
            <div>
              <label className="form-label">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-input"
                required
              />
            </div>
            <div>
              <label className="form-label">Description</label>
              <input
                type="text"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>
            <div>
              <label className="form-label">Length (minutes)</label>
              <input
                type="number"
                name="length"
                value={formData.length}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>
            <div className="modal-actions">
              <button type="button" onClick={() => setIsModalOpen(false)}>
                Cancel
              </button>
              <button type="submit" disabled={loading}>
                {loading ? 'Adding...' : 'Add Request Type'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default RequestTypeManager; 